/**
 * Russian counts, agreeing with the number in front of them.
 *
 * The product prints counted nouns in several places and each one had grown
 * its own copy of this rule, or had skipped it — "Ещё 162 контрактов прошли
 * отбор" stood on the ranking screen for as long as that line existed.
 * Written once, because the rule belongs to the language rather than to any
 * one screen, and a copy per screen is a copy that gets forgotten.
 *
 * The three forms Russian asks for: one, few (two to four), and many. The
 * teens are the exception that catches every naive version — eleven through
 * fourteen take the many form despite ending in one to four.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  const whole = Math.abs(Math.trunc(count));
  if (whole % 100 >= 11 && whole % 100 <= 14) return many;
  const last = whole % 10;
  if (last === 1) return one;
  if (last >= 2 && last <= 4) return few;
  return many;
}
